import {Injectable} from '@angular/core';
import {OverlayElementEditor} from 'app/shared/classes/overlay-element-editor';
import {Observable, Subject} from 'rxjs';
import {Constructor} from '../interfaces/common.interface';
import {
    OverlayComponentInputs,
    OverlayComponentOutputs,
    OverlayHideRequest,
    OverlayRenderRequest,
    OverlayRequestCallback,
} from '../interfaces/overlay.interface';

@Injectable()
export class OverlayService {
    private renderSubject$ = new Subject<OverlayRenderRequest>();
    private hideSubject$ = new Subject<OverlayHideRequest>();
    private inputsSubject$ = new Subject<{id: string; inputs: OverlayComponentInputs}>();
    private overlayEditorSubject$ = new Subject<{id: string; callback: OverlayRequestCallback}>();
    render$: Observable<OverlayRenderRequest> = this.renderSubject$.asObservable();
    hide$: Observable<OverlayHideRequest> = this.hideSubject$.asObservable();
    inputs$: Observable<{id: string; inputs: OverlayComponentInputs}> = this.inputsSubject$.asObservable();
    overlayEditor$: Observable<{id: string; callback: OverlayRequestCallback}> = this.overlayEditorSubject$.asObservable();

    constructor() {}

    renderTemplate(
        component: Constructor<any>,
        inputs?: OverlayComponentInputs,
        outputs?: OverlayComponentOutputs
    ): Promise<OverlayElementEditor> {
        return new Promise(resolve => {
            this.renderSubject$.next({
                component,
                inputs,
                outputs,
                callback: editor => resolve(editor),
            });
        });
    }

    hideTemplate(id: string): Promise<OverlayElementEditor> {
        return new Promise(resolve => {
            this.hideSubject$.next({
                id,
                callback: editor => resolve(editor),
            });
        });
    }

    updateInputs(id: string, inputs: OverlayComponentInputs) {
        this.inputsSubject$.next({
            id,
            inputs,
        });
    }

    getOverlayEditor(id: string): Promise<OverlayElementEditor> {
        return new Promise<OverlayElementEditor>(resolve => {
            this.overlayEditorSubject$.next({
                id,
                callback: editor => resolve(editor),
            });
        });
    }
}
